const WEEKDAY_HEADER = ['S', 'M', 'T', 'W', 'T', 'F', 'S']
const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const pad = n => String(n).padStart(2, '0')
const toDateKey = (y, m, d) => `${y}-${pad(m + 1)}-${pad(d)}`

const bucketClass = (count) => {
    if (!count) return 'bg-transparent'
    if (count === 1) return 'bg-accent/20'
    if (count <= 3) return 'bg-accent/40'
    if (count <= 5) return 'bg-accent/70'
    return 'bg-accent'
}

function MonthBlock({ year, month, dayCounts, onDayClick }) {
    const startOffset = new Date(year, month, 1).getDay()
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    const cells = [...Array(startOffset).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)]

    return (
        <div className="border-2 border-black dark:border-white p-3">
            <p className="mb-2 font-mono text-sm font-bold uppercase text-black dark:text-white">{MONTH_NAMES[month]}</p>
            <div className="grid grid-cols-7 gap-1">
                {WEEKDAY_HEADER.map((w, i) => (
                    <span key={i} className="text-center font-mono text-[10px] text-zinc-400">{w}</span>
                ))}
                {cells.map((day, i) => {
                    if (day === null) return <span key={i} />
                    const key = toDateKey(year, month, day)
                    const count = dayCounts.get(key) || 0
                    return (
                        <button
                            key={i}
                            type="button"
                            title={`${MONTH_NAMES[month]} ${day}, ${year}: ${count} event${count === 1 ? '' : 's'}`}
                            onClick={() => onDayClick(new Date(year, month, day))}
                            className={[
                                'aspect-square w-full border border-black/20 dark:border-white/20 transition-transform hover:scale-110',
                                bucketClass(count),
                            ].join(' ')}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default function YearHeatmap({ year, dayCounts, onDayClick }) {
    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {MONTH_NAMES.map((_, month) => (
                <MonthBlock key={month} year={year} month={month} dayCounts={dayCounts} onDayClick={onDayClick} />
            ))}
        </div>
    )
}
